import { gql } from '@apollo/client';

export const DELETE_HIERARCHY = gql`
  mutation DeleteHierarchy($id: ID!) {
    hierarchy: deleteHierarchy(id: $id) {
      id
    }
  }
`;
